import { PROFILE_STATUS, useVerifyProfile } from '@/providers/VerifyProfileProvider';
import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Flex, type MantineSize, Text } from '@mantine/core';
export type KycStepperStatusProps = {
  visible?: MantineSize | (string & {}) | undefined;
  hidden?: MantineSize | (string & {}) | undefined;
};
export const ProfileStepperStatus: React.FC<KycStepperStatusProps> = ({
  visible,
  hidden
}) => {
  const {
    i18n
  } = useLingui();
  const {
    successes
  } = useVerifyProfile();
  return <Flex w="100%" justify={{
    base: 'center',
    sm: 'end',
    lg: 'center'
  }} visibleFrom={visible} hiddenFrom={hidden}>
      {!successes.has(PROFILE_STATUS.VERIFICATION) && <Text px={16} className={gunterzBold.className} fz={13} c="var(--text-dark)" mb={8}>
          <Text span inherit c="var(--text-green)">
            {successes.size}
          </Text>
          {i18n._(' of 4 complete')}
        </Text>}
    </Flex>;
};